import { render, staticRenderFns } from "./RelationList.vue?vue&type=template&id=f8ae2a56&"
import script from "./RelationList.vue?vue&type=script&lang=js&"
export * from "./RelationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports